import { create } from "zustand";
import { INIT_API } from "@/constants/urls";
import axiosInstance from "./../../lib/axiosInstance";
import { devLogError } from "@/lib/sentryCaptureException";

// interface AppSetting {
//   isDark: boolean;
//   initSetting: InitSetting;
//   setDarkTheme: (theme: boolean) => void;
//   setInitSetting: () => void;
// }

// export const useAppSettings =  create <  AppSetting >  ((set) => ({
export const useAppSettings = create((set, get) => ({
  isDark: false,
  myAccount: {},
  initLoading: true,
  initSetting: {},
  userCellphone: "",
  AdtraceSdk: null,
  queryData: {},
  adtraceAdId: "",
  appInjectedData: {},
  isOpenedInApplication: false,
  isGoToLoading: false,
  redirectRoute: "",
  myPhoneNumber: "",
  fcmToken: "",

  setDarkTheme: (theme) => set((state) => ({ ...state, isDark: theme })),
  setFcmToken: (token) => set((state) => ({ ...state, fcmToken: token })),

  setCallSetting: async () => {
    try {
      const response = await axiosInstance.get(INIT_API, {});
      if (response) {
        get().setInitSetting(response.data);
        return response.data;
      }
    } catch (error) {
      set((state) => ({ ...state, initLoading: false }));
      devLogError(error);
    }
  },

  setInitSetting: (_initData) => {
    if (_initData) {
      set((state) => ({
        ...state,
        initSetting: { ..._initData?.settings },
        myAccount: { ..._initData?.account },
        userCellphone: _initData?.user_cellphone,
        userKycStatus: _initData?.user_kyc_status,
        userVpnStatus: _initData?.user_vpn_status,
        initLoading: false,
      }));
    } else {
      set((state) => ({ ...state, initLoading: false }));
    }
  },
  setInitLoading: () => set((state) => ({ ...state, initLoading: false })),
  setAccountAvatar: (_img) => {
    try {
      const _myAccount = { ...get().myAccount };
      const userTypeInfo = _myAccount[_myAccount.type.toLowerCase()];
      userTypeInfo.profile_image_url = _img;
      set((state) => ({
        ...state,
        myAccount: { ..._myAccount },
      }));
    } catch (error) {
      // // SentryCaptureException(error);
      devLogError(error);
    }
  },
  setAdtraceSdk: (data) => set((state) => ({ ...state, AdtraceSdk: data })),
  setAppQueryData: (_queryData) =>
    set((state) => ({ ...state, queryData: { ...state.queryData, ..._queryData } })),
  setAdtraceAdId: (adid) => set((state) => ({ ...state, adtraceAdId: adid })),
  setAppInjectedData: (data) => set((state) => ({ ...state, appInjectedData: data })),
  setIsOpenedInApp: (status) => set((state) => ({ ...state, isOpenedInApplication: status })),
  setIsGoToLoading: (status) => set((state) => ({ ...state, isGoToLoading: status })),
  setRedirectRoute: (_route) => set((state) => ({ ...state, redirectRoute: _route })),
  setMyPhoneNumber: (phoneNumber) => set((state) => ({ ...state, myPhoneNumber: phoneNumber })),
}));
